module.exports = __webpack_public_path__ + "static/media/slide-6.91261ed5.png";